module.exports = __webpack_public_path__ + "img/box_pro_two_6.ffbfec8d.jpg";